import { Api } from '../api';
import { integrations } from '../endpoints';
import type { ApiResponse, ApiPaginate } from '../../models';
import type {
  AccountTypeFieldResponse,
  ConfirmConnectRequest,
  DisconnectAccountRequest,
  IntegrationResponse,
  IntegrationLoginUrlResponse,
  IntegrationType,
  SetAccountTypeRequest,
} from './models';

export class IntegrationsApi extends Api {
  static getIntegrations = (signal?: AbortSignal) => this.get<ApiPaginate<IntegrationResponse[]>>({ url: integrations.get(), signal });

  static connect = (service: IntegrationType, signal?: AbortSignal) =>
    this.post<IntegrationType, ApiResponse<IntegrationLoginUrlResponse>>({ url: integrations.connect(service), signal });

  static confirmConnect = ({ service, code }: ConfirmConnectRequest, signal?: AbortSignal) =>
    this.post<ConfirmConnectRequest, ApiResponse<void>>({ url: integrations.confirm(service, code), signal });

  static disconnect = (service: IntegrationType, signal?: AbortSignal) =>
    this.delete<IntegrationType, ApiResponse<void>>({ url: integrations.disconnect(service), signal });

  static disconnectAccount = ({ service, accountId }: DisconnectAccountRequest, signal?: AbortSignal) =>
    this.post<DisconnectAccountRequest, ApiResponse<void>>({ url: integrations.disconnectAccount(service, accountId.toString()), signal });

  static getAccountTypes = (signal?: AbortSignal) =>
    this.get<ApiResponse<AccountTypeFieldResponse>>({ url: integrations.getXeroAccountTypes(), signal });

  static setAccountType = ({ accountId, accountType }: SetAccountTypeRequest, signal?: AbortSignal) =>
    this.put<SetAccountTypeRequest, ApiResponse<void>>({ url: integrations.setXeroAccountType(accountId.toString(), accountType), signal });
}
